import axios from 'axios';

const recordConsent = (documents: string[]): Promise<void> => {
  return axios.post('/qualification/record_consent', {
    documentKeys: documents,
  });
};

const recordOfferConsent = (offerId: string): Promise<void> => {
  return axios.post('/qualification/record_offer_consent', { offerId });
};

export { recordConsent, recordOfferConsent };
